module.exports = __webpack_public_path__ + "img/poopee.81ed30b5.svg";